import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
export default function AdministrationBackLink(){return <Link to="/config" className="mb-4 inline-flex min-h-10 items-center gap-2 rounded-lg border bg-white px-3 text-sm font-semibold text-slate-700 hover:bg-slate-50"><ArrowLeft size={16}/>Back to Administration</Link>}
